<template>
  <div>
    <v-select
      v-model="selected_inbox"
      :items="inbox_choices"
      :label="label"
      :hint="hint"
      :disabled="inbox_choices.length === 0"
      :hide-details="hide_details"
      :persistent-hint="Boolean(hint)"
      dense
      @change="onChange"
    >
      <template #append-outer>
        <div v-if="show_manage_inboxes && inbox_choices.length !== 0">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                icon
                :to="{
                  name: 'edit-inboxes',
                  params: { organization_id }
                }"
              >
                <slot name="manage-inboxes-icon">
                  <v-icon color="primary" size="20" aria-hidden="true">mdi-inbox</v-icon>
                </slot>
              </v-btn>
            </template>
            <span>Manage Inboxes</span>
          </v-tooltip>
        </div>
      </template>
    </v-select>
    
    <slot name="append-below" />
  </div>
</template>

<script>
export default {
  name: 'SelectInbox',

  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    organization_id: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      default: 'Select Inbox',
    },
    hint: {
      type: String,
      default: 'Select which inbox should receive messages',
    },
    hide_details: {
      type: Boolean,
      default: false,
    },
    /**
     * Whether to show the "Manage Inboxes" button appended to the select field
     */
    show_manage_inboxes: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      inbox_choices: [],
    };
  },

  computed: {
    selected_inbox: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  mounted() {
    this.loadInboxes();
  },

  methods: {
    loadInboxes() {
      this.$rc.rest(
        'LIST: /api/v1/inboxes',

        {
          organization_id: this.organization_id,
          is_archived: false,
        },

        (data) => {
          const inboxes = data.results;
          const inbox_choices = [];

          for (let i = 0; i < inboxes.length; i++) {
            inbox_choices.push({
              text: inboxes[i].internal_label,
              value: inboxes[i].inbox_id,
            });
          }

          this.inbox_choices = inbox_choices;
          this.$emit('inboxes-loaded', inbox_choices);
        },

        () => {
          this.$rc.alert('Error', 'Unable to list inboxes');
        },
      );
    },

    onChange() {
      this.$emit('change', this.selected_inbox);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-input__append-outer) {
  margin-bottom: 0;
}
</style>